var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sliderChart" },
    _vm._l(_vm.ratingLabels, function (rating) {
      return _c("div", { key: rating, staticClass: "sliderChart__item" }, [
        _c("div", { staticClass: "sliderChart__label" }, [
          _vm._v(_vm._s(rating.toFixed(1))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sliderChart__container" }, [
          _c(
            "div",
            {
              staticClass: "sliderChart__slider",
              style: { "--width": _vm.calculatedWidth(rating) },
            },
            [
              _vm.ratingCounts[rating] > 0
                ? _c("div", {
                    staticClass: "sliderChart__thumb",
                    style: { left: _vm.calculatedWidth(rating) },
                  })
                : _vm._e(),
            ]
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }